/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LivewatchPlanDetailInfo } from './LivewatchPlanDetailInfo';

export type LivewatchPlanInfo = {
    APTS: string;
    DCTSUBTP: LivewatchPlanInfo.DCTSUBTP;
    SB: string;
    DATA: Array<LivewatchPlanDetailInfo>;
};

export namespace LivewatchPlanInfo {

    export enum DCTSUBTP {
        OBJECTIVE_RETENTION_PLAN = 'OBJECTIVE_RETENTION_PLAN',
        OBJECTIVE_DISTRIBUTION_PLAN = 'OBJECTIVE_DISTRIBUTION_PLAN',
    }


}

